(function(){
    'use strict';

    // Check if load screen was already shown for this window
    if (null !== sessionStorage.getItem('load-screen')) {
        return;
    }

    // Check if load screen was shown in the last hour
    const prevSession = parseFloat(localStorage.getItem('load-screen'));
    const currentDate = new Date();

    if (null !== prevSession) {
        const sessionTimeout = new Date(prevSession + 3600000);

        if (currentDate <= sessionTimeout) {
            return;
        }
    }

    document.body.classList.add('has-load-screen');
    localStorage.setItem('load-screen', currentDate.getTime());
    sessionStorage.setItem('load-screen', true);

    const runLoadScreen = () => {
        const loadScreen = document.createElement('div');
        loadScreen.id = 'load-screen';
    
        const player = document.createElement('lottie-player');
        player.src = '/theme/assets/Partner_loading.json';
        player.autoplay = true;
        player.loop = true;
    
        loadScreen.appendChild(player);
        document.body.insertAdjacentElement('afterbegin', loadScreen);
    
        let loaded = false;
        let timeout = false;
    
        setTimeout(() => {
            timeout = true;
    
            if (loaded) {
                document.body.classList.add('hide-load-screen');
            }    
        }, 2600);
    
        window.addEventListener('load', () => {
            loaded = true;
    
            if (timeout) {
                document.body.classList.add('hide-load-screen');
            }
        });
    };

    // Check if lottie has already been loaded
    if (null !== document.getElementById('lottie-player-script')) {
        runLoadScreen();
    } else {
        // Load lottie manually
        const script = document.createElement('script');
        script.src = '/bundles/contaolottieplayer/lottie-player.js';
        document.body.prepend(script);
        script.addEventListener('load', runLoadScreen);
    }
})();
